// extracted by mini-css-extract-plugin
export var avatar = "Comments-module--avatar--1qRP2";
export var commentLoader = "Comments-module--commentLoader--mDfEP";
export var commentLoaderWrapper = "Comments-module--commentLoaderWrapper--Wh5Rn";
export var contentText = "Comments-module--contentText--Vu8ju";
export var dateTime = "Comments-module--dateTime--vXset";
export var name = "Comments-module--name--vlbov";
export var nameContentWrap = "Comments-module--nameContentWrap--Dfk-N";
export var nameOptions = "Comments-module--nameOptions--NsZT-";
export var navAn = "Comments-module--navAn--rXmPC";
export var options = "Comments-module--options--iW1zJ";
export var originalPost = "Comments-module--originalPost--SKs3E";
export var reply = "Comments-module--reply--uGmtu";
export var replyIcon = "Comments-module--replyIcon--Ac++g";
export var replyInfo = "Comments-module--replyInfo--AsEtT";
export var targetPost = "Comments-module--targetPost--CJwHm";
export var wholeCommentWrapper = "Comments-module--wholeCommentWrapper--OHu61";
export var wholeSubCommentWrapper = "Comments-module--wholeSubCommentWrapper--lGkjg";
export var wrapper = "Comments-module--wrapper--9qxfh";